import { gql, useQuery } from '@apollo/client'

const useEducatorsObservations = (vars = {}) => {
    const { data, loading, error, refetch } = useQuery(
        gql`
        query {
            getEducatorsObservations {
                _id
                firstName
                lastName
                frecuencyObservations
                observationsBy {
                    staffId
                    staffName}
                observationsDates {
                        date
                        staffId
                        staffName
                        }
                hasStudents    
                educatorInfo {
                        educatorNote
                        }
            }  
        }`,
        {
            variables: vars,
            fetchPolicy: 'cache-first',
        }
    );

    return { data: data ? data.getEducatorsObservations : [], loading, error, refetch };
}

export default useEducatorsObservations;